<div class="dialog-outer-wrapper">
  <h2 i18n-title="@@ReplenishmentOptionsTitle" title="Replenishment Options" i18n="@@Replenishment Options">Replenishment Options</h2>
  <div style="margin-bottom: 8px;">
    <span i18n-title="@@UtilizationBefore" title="Utilization Before" i18n="@@Current Utilization:">Current Utilization:</span>
    <b>{{utilizationBefore}}%</b>
  </div>
  <div *ngIf="filteredProducts.length === 0">
    <span i18n-title="@@NoOptionsAvailable" title="No options available" i18n="@@No options available">No options available</span>
    <div class="btn-sec">
      <button mat-raised-button class="Discard-btn" (click)="cancel()" i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel" title="Cancel" i18n="@@Cancel">Cancel</button>
    </div>
  </div>
  <div *ngIf="filteredProducts.length > 0">
    <div class="filter-bar">
      <mat-checkbox [checked]="hideTrimMismatches"
                    (change)="setHideTrimMismatches($event.checked)">
        <span i18n="@@HideTrimSizeMismatches">Hide options with mismatched trim size</span>
      </mat-checkbox>
      <span class="filter-bar-hint" *ngIf="hideTrimMismatches && hiddenCount > 0">
        <ng-container i18n="@@hiddenOptionsHint">{{hiddenCount}} option(s) hidden</ng-container>
      </span>
    </div>
    <div class="scroll-table-wrapper">
      <table>
        <thead>
          <tr>
             <th i18n-title="@@BookID" title="Book Id" i18n="@@Book Id">Book Id</th>
             <th i18n-title="@@Title" title="Title"><span i18n="@@Title">Title</span><br><span style="font-weight:normal;font-size:smaller" i18n="@@Trim Size">Trim Size</span></th>
             <th i18n-title="@@NumPages" title="Number of Pages" i18n="@@Pages">Pages</th>
             <th i18n-title="@@NetInventory" title="Net Inventory" i18n="@@Net Inventory">Net Inventory</th>
             <th i18n-title="@@SheetsAdded" title="Sheets Added" i18n="@@Sheets Added">Sheets Added</th>
             <th i18n-title="@@InventoryScore" title="Inventory Score" i18n="@@Inv. Score">Inv. Score</th>
             <th i18n-title="@@UtilizationAfter" title="Utilization After" i18n="@@Util. After (%)">Util. After (%)</th>
             <th i18n-title="@@FillQty" title="Quantity to Add" i18n="@@Qty to Add">Qty to Add</th>
             <th i18n-title="@@Select" title="Select" i18n="@@Select">Select</th>
          </tr>
        </thead>
        <tbody>
           <tr *ngFor="let option of visibleProducts()">
             <td>
               <ng-container *ngIf="option.book_IDs && option.book_IDs.length > 1; else singleBookId">
                 <div *ngFor="let id of option.book_IDs">{{id}}</div>
               </ng-container>
               <ng-template #singleBookId>{{option.book_IDs ? option.book_IDs[0] : option.book_ID}}</ng-template>
             </td>
             <td>
               <ng-container *ngIf="option.titles && option.titles.length > 1; else singleTitle">
                 <div *ngFor="let t of option.titles; let i = index">
                   <span [ngClass]="{'red': option.trimSizes[i] !== getSetTrimSizeString()}" style="font-weight: bold">{{t}}</span>
                   <div style="font-size:smaller; color: #666;">{{option.trimSizes[i]}}</div>
                 </div>
               </ng-container>
               <ng-template #singleTitle>
                 <span [ngClass]="{'red': option.trimSizes[0] !== getSetTrimSizeString()}" style="font-weight: bold">{{option.titles ? option.titles[0] : option.title}}</span>
                 <div style="font-size:smaller; color: #666;">{{option.trimSizes ? option.trimSizes[0] : ''}}</div>
               </ng-template>
             </td>
             <td>
               <ng-container *ngIf="option.numPages && option.numPages.length > 1; else singleNumPages">
                 <div *ngFor="let n of option.numPages">{{n}}</div>
               </ng-container>
               <ng-template #singleNumPages>{{option.numPages ? option.numPages[0] : option.numPages}}</ng-template>
             </td>
             <td>
               <ng-container *ngIf="option.netInventories && option.netInventories.length > 1; else singleNetInv">
                 <div *ngFor="let n of option.netInventories">{{n}}</div>
               </ng-container>
               <ng-template #singleNetInv>{{option.netInventories ? option.netInventories[0] : option.netInventory}}</ng-template>
             </td>
             <td>{{option.sheetsAdded}}</td>
             <td>
               <ng-container *ngIf="option.inventoryScores && option.inventoryScores.length > 1; else singleInvScore">
                 <div *ngFor="let s of option.inventoryScores">{{s !== null && s !== undefined ? (s | number:'1.0-0') : ''}}</div>
               </ng-container>
               <ng-template #singleInvScore>{{option.inventoryScores ? (option.inventoryScores[0] !== null && option.inventoryScores[0] !== undefined ? (option.inventoryScores[0] | number:'1.0-0') : '') : (option.inventoryScore !== null && option.inventoryScore !== undefined ? (option.inventoryScore | number:'1.0-0') : '')}}</ng-template>
             </td>
             <td>
               {{option.utilizationAfter}}%
               <span *ngIf="option.utilizationDelta !== 0">
                 <span [ngClass]="{'arrow-up': option.utilizationDelta > 0, 'arrow-down': option.utilizationDelta < 0, 'green': option.utilizationDelta > 0, 'red': option.utilizationDelta < 0}">
                   <ng-container *ngIf="option.utilizationDelta > 0">&#8593;</ng-container>
                   <ng-container *ngIf="option.utilizationDelta < 0">&#8595;</ng-container>
                 </span>
                 <span [ngClass]="{'green': option.utilizationDelta > 0, 'red': option.utilizationDelta < 0}">
                   {{option.utilizationDelta > 0 ? '+' : ''}}{{option.utilizationDelta}}%
                 </span>
               </span>
             </td>
             <td>
               <ng-container *ngIf="option.quantities && option.quantities.length > 1; else singleQty">
                 <div *ngFor="let q of option.quantities">{{q}}</div>
               </ng-container>
               <ng-template #singleQty>{{option.quantities ? option.quantities[0] : option.fillQty}}</ng-template>
             </td>
             <td>
               <button mat-button (click)="selectProduct(option)" i18n-title="@@Select" title="Select" i18n="@@Select">Select</button>
             </td>
           </tr>
        </tbody>
      </table>
    </div>
    <!--
      `btn-sec` is the class every dialog in this app uses for its
      action row, and `src/dialogs.css` hangs the shared footer bar off
      it. Dismiss first, commit last, matching every other dialog.
    -->
    <div class="btn-sec">
      <button mat-raised-button class="Discard-btn" (click)="cancel()" i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel" title="Cancel" i18n="@@Cancel">Cancel</button>
      <button mat-raised-button color="primary" class="Update-btn" (click)="confirm()" [disabled]="!selectedOption" i18n-title="@@Confirm" title="Confirm" i18n="@@Confirm">Confirm</button>
    </div>
  </div>
</div>

<style>
/*
  No padding, no background, no radius and no max-height here.

  This element is the dialog TEMPLATE ROOT. The card around it is
  `.mat-mdc-dialog-surface`, which `src/dialogs.css` already paints,
  rounds, borders and shadows, and which also owns the scrolling and
  the 24px body gutter. Painting a second white rounded box here drew
  a card inside a card -- a 12px radius sitting 24px inside a 14px one
  -- and kept the title band from ever reaching the real edge. The
  shared skin owns the chrome; this file owns the table.
*/
.dialog-outer-wrapper {
  box-sizing: border-box;
  max-width: 900px;
  min-width: 400px;
}
.scroll-table-wrapper {
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 16px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 4px 8px;
  border: 1px solid #ccc;
  text-align: left;
}
/* Pin the header row inside the scrolling wrapper so column labels remain
   visible while the user scrolls through option rows. The background
   prevents row content from showing through; the box-shadow draws a
   subtle separator line below the header during scroll. */
thead th {
  position: sticky;
  top: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: 0 1px 0 0 #ccc;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
}
.filter-bar-hint {
  color: #777;
  font-size: 12px;
  font-style: italic;
}
.arrow-up {
  font-weight: bold;
  margin-left: 4px;
}
.arrow-down {
  font-weight: bold;
  margin-left: 4px;
}
.green {
  color: #388e3c;
}
.red {
  color: #d32f2f;
}
.icon-stack {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
}
.icon-stack mat-icon {
  font-size: 28px;
  vertical-align: middle;
}
.icon-plus {
  position: absolute;
  top: -2px;
  right: -4px;
  font-size: 22px;
  font-weight: bold;
  color: #388e3c;
  background: transparent;
  width: 22px;
  height: 22px;
  line-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
  text-shadow: 0 0 4px #fff, 0 0 4px #fff, 0 0 3px #388e3c;
}
</style>
